export default __webpack_public_path__ + "static/blob5-e07155b6d9e3407b598d5972661aad2d.svg";